(function(){
  document.body.classList.add('willow-pdp');
  function place(){
    var box = document.querySelector('.willow-info');
    if(!box || box.dataset.wvPlaced){ return; }
    var col = document.querySelector('.willow-pdp .product__info') || document.querySelector('.product__info');
    if(!col){ return; }
    col.appendChild(box);
    box.hidden = false;
    box.dataset.wvPlaced = '1';
  }
  /* Move "What's Included" out of the accordion stack to sit right under the YOUR SELECTION
     summary (the configurator builds .wv-summary). Re-runs keep it glued if the summary
     re-renders on a variant change. */
  function placeIncl(){
    var incl = document.querySelector('.wv-incl'), sum = document.querySelector('.wv-summary');
    if(!incl || !sum){ return; }
    if(sum.nextElementSibling !== incl){ sum.parentNode.insertBefore(incl, sum.nextElementSibling); }
  }
  function clampDesc(){
    var desc = document.querySelector('.willow-acc-desc');
    if(!desc || desc.dataset.wvMore){ return; }
    var body = desc.querySelector('.willow-acc-body');
    if(!body){ return; }
    // Only worth a toggle if there's actually overflow to hide on a narrow screen.
    if(body.scrollHeight <= body.clientHeight + 4 && window.matchMedia('(max-width: 768px)').matches){ return; }
    desc.dataset.wvMore = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'willow-desc-more';
    btn.textContent = 'Read more';
    body.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function(){
      var ex = desc.classList.toggle('is-expanded');
      btn.textContent = ex ? 'Show less' : 'Read more';
    });
  }
  function run(){ place(); placeIncl(); clampDesc(); }
  if(document.readyState !== 'loading'){ run(); } else { document.addEventListener('DOMContentLoaded', run, { once:true }); }
  /* The configurator can be replaced after a variant change. Re-place only around that real event
     instead of querying the page forever every 1.5 seconds. */
  document.addEventListener('variant:change', function(){
    requestAnimationFrame(function(){ placeIncl(); clampDesc(); });
  });
  [300, 1000, 2200].forEach(function(t){ setTimeout(run, t); });
})();
